import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LandlordContactTable from "./LandlordContactTable";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import { clientAccess } from "../../utils/index";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class LandlordContactDetails extends React.Component {
  state = {
    url: `${apiUrl.apiUrl.url}/broker/create-contact`,
    clientGroups: [],
    clientList: [],
    companyId: "",
    isOpen: false,
    brokerGroups: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    companyName: [],
    redirect: false,
    id: undefined,
    initialValues: {
      cgroupId: "",
      cgroupName: "",
      clientId: "",
      clientName: "",
      companyId: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
      contactDepartment: "",
      companyGroup: "",
    },
  };
  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          clientGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    //fetch(`${apiUrl.apiUrl.url}/broker-groups`)
    fetch(`${apiUrl.apiUrl.url}/broker-group/fetch-broker-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brokerGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  changeGroup = (e) => {
    let groupid = e.value;
    fetch(`${apiUrl.apiUrl.url}/broker/get-group-companies/?id=` + groupid, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.initialValues.groupName = e.label;
        this.state.initialValues.groupId = e.label;
        this.state.initialValues.companyGroup = e.value;

        this.state.initialValues.companyName = '';
        this.state.initialValues.companyId = '';
        this.setState({
          companyName: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  changeCompany = (e) => {
    let groupid = e.value;
    console.log(e, "==")
    this.state.initialValues.companyId = e.value;
    this.state.initialValues.companyName = e.label;
    //this.state.companyId = e.value;
    this.setState({})

    fetch(`${apiUrl.apiUrl.url}/broker/get-company/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          //companyId: data.id,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  constructor(props) {
    super(props);
  }

  checkDelete() {
    var self = this;
    self.setState({
      delete: true
    });

  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/broker/create-contact`,
          initialValues: {
            cgroupId: "",
            cgroupName: "",
            clientId: "",
            clientName: "",
            companyId: "",
            contactName: "",
            contactNumber: "",
            contactEmail: "",
            contactDepartment: "",
            companyGroup: "",
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/broker/fetch-contact?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/broker/update-contact?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            // occupierGroups: data.groups,
            companyName: data.companies,
            clientGroups: data.clientGroups,
            clientList: data.clientList,
          });
        }).catch((err) => {});

        // fetch(
        //   `${apiUrl.apiUrl.url}/broker/fetch-contact?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/broker/update-contact?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       // occupierGroups: data.groups,
        //       companyName: data.companies,
        //       clientGroups: data.clientGroups,
        //       clientList: data.clientList,
        //     });
        //     console.log(this.state.initialValues, "iv");
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }
  handleChangeclientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.cgroupId = newValue.value;
      this.state.initialValues.cgroupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    //this.cgroupId = newValue;
    //console.log(this.cgroupId, "ddd");
    //console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/broker/delete-contact?id=${this.state.id}`,
    }).then(function (response) {

      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",

        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        cgroupId: "",
        cgroupName: "",
        clientId: "",
        clientName: "",
        companyId: "",
        companyName: "",
        contactName: "",
        contactNumber: "",
        contactEmail: "",
        contactDepartment: "",
        companyGroup: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        cgroupId: "",
        cgroupName: "",
        clientId: "",
        clientName: "",
        companyId: "",
        companyName: "",
        contactName: "",
        contactNumber: "",
        contactEmail: "",
        contactDepartment: "",
        companyGroup: "",
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/broker-contact-details" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    console.log(this.state.assetNameValues);
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/broker-directory">Broker Directory</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Broker Contact Details</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values);
            var self = this;
            values.companyId = this.state.initialValues.companyId;
            values.clientId = this.state.initialValues.groupId;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!"
                });

              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeclientGroup(e, "change_client_group");
                              }}
                              value={{
                                label: this.state.initialValues.cgroupName,
                                value: this.state.initialValues.cgroupId,
                              }}
                              options={this.state.clientGroups.map((item) => ({
                                label: item.group_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientGroup" component="div" className="text-red" />
                          </div>
                        </div>
                      )}
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeclientGroup(e, "change_client_name");
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientName" component="div" className="text-red" />
                          </div>
                        </div>
                      )}
                      <div className="newGridSectionInner">
                        <label>
                          Company Group <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="companyGroup"
                            onChange={(e) => {
                              this.changeGroup(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.brokerGroups.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="companyGroup" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Company Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="companyId"
                            onChange={(e) => {
                              this.changeCompany(e);
                            }}
                            value={{
                              label: this.state.initialValues.companyName,
                              value: this.state.initialValues.companyId,
                            }}
                            options={this.state.companyName.map((item) => ({
                              label: item.company_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="companyId" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Person Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="contactName" />
                          <ErrorMessage name="contactName" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Mobile Number <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="contactNumber" />
                          <ErrorMessage name="contactNumber" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Email Id <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="contactEmail" />
                          <ErrorMessage name="contactEmail" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Department <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="contactDepartment"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="Leasing" label="Leasing" />
                            <option value="Sales & Marketing" label="Sales & Marketing" />
                            <option value="Business Development" label="Business Development" />
                            <option value="Asset Operations" label="Asset Operations" />
                            <option value="Finance & Accounts" label="Finance & Accounts" />
                            <option value="Head Office" label="Head Office" />
                            <option value="Owner Director Partner" label="Owner Director Partner" />
                          </Field>
                          <ErrorMessage name="contactDepartment" component="div" className="text-red" />
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/broker-contact-details">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>

              
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <LandlordContactTable />
      </>
    );
  }
}

export default withRouter(LandlordContactDetails);
